<template>
  <div>
    <main>
      <div class="wide-wrapper">
        <h2>Contrology Handbook</h2>
        <h3></h3>

        <div class="upper-content-wrapper">
          <photo-grid :feature="featureImgHtml">
            <photo
              @setFeature="setFeatureImg"
              src="ref-handbook-book@1x.jpg"
              src2="ref-handbook-book@2x.jpg"
              alt="Photo of book cover for Contrology Handbook"
            />
          </photo-grid>

          <!-- <cta-prod-button
            class="cta-button wide"
            link="cadillac"
            src="contrology-cad1@1x.jpg"
            src2="contrology-cad1@2x.jpg"
            alt="Close-up photo of Contrology Cadillac thumbnail"
            productName="Contrology Cadillac"
            productSub='All models'
          /> -->

          <div class="content-wrapper">
            <section class="intro">
              <h2>Contrology Handbook</h2>
              <h3></h3>
              <p>
                Authored by Vintage Pilates owner Sandy Shimoda and dedicated to first generation Pilates instructor Jay Grimes, this comprehensive guide is for all students of Contrology, Joe's method of corrective exercise.
              <span
                  v-show="!show"
                  class="content-link"
                  @click="toggleContent"
                  role="button"
                  tabindex="0"
                >
                  More ›
                </span>
              </p>
              <div v-show="show">
                <p>It is aimed at clarifying Joe’s ideas about his method, what makes it different from other forms of exercise, and how to get the results Joe intended. The perfect gift for Pilates professionals and enthusiasts interested in the “why” behind the “how” of Pilates! Hardcover, 104 pages, 28 original illustrations and artwork.
                  <span
                    v-show="show"
                    class="content-link"
                    @click="toggleContent"
                    role="button"
                    tabindex="0"
                  >
                    Less ›
                  </span>
                </p>
              </div>
            </section>

            <product-selector
              :products=products
              :product=product
              :option1=option1
              :option2=option2
              :isdistcountry=isdistcountry
              additionalText=""
            />

            <section class="links">
              <!-- <icon-link
                url="support#returns"
                img="icon-warranty.svg"
                alt="Warranty icon"
                title="Learn more"
              >Limited Lifetime Warranty</icon-link> -->
              <icon-link
                url="support#returns"
                img="icon-guarantee.svg"
                alt="Guarantee icon"
                title="Learn more"
              >30-Day Money Back Guarantee</icon-link>
              <!-- <icon-link
                url="support"
                img="icon-assembly.svg"
                alt="Assembly icon"
                title="Learn more"
              >Assembly &amp; Support</icon-link> -->
            </section>

            <!-- <cta-prod-button
              class="cta-button"
              link="cadillac"
              src="contrology-cad1@1x.jpg"
              src2="contrology-cad1@2x.jpg"
              alt="Close-up photo of Contrology Cadillac thumbnail"
              productName="Contrology Cadillac"
              productSub='All models'
            />
            
            <section class="more">
              <tertiary-button text="More Cadillac Accessories" url="/accessories/Cadillac" />
            </section> -->
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import PhotoGrid from "@/components/PhotoGrid.vue";
import Photo from "@/components/Photo.vue";
import ProductSelector from "@/components/ProductSelector.vue";
import IconLink from "@/components/IconLink.vue";
// import CtaProdButton from "@/components/CtaProdButton.vue";
// import TertiaryButton from "@/components/TertiaryButton.vue";

export default {
  name: "contrologyhandbook",

  metaInfo: {
    title: "Contrology Handbook",
    titleTemplate: "%s",
    meta: [
      {
        name: "description",
        content: "Authored by Vintage Pilates owner Sandy Shimoda and dedicated to first generation Pilates instructor Jay Grimes, this comprehensive guide is for all students of Contrology, Joe's method of corrective exercise."
      }
    ]
  },

  components: {
    PhotoGrid,
    Photo,
    ProductSelector,
    IconLink,
    // CtaProdButton,
    // TertiaryButton
  },

  props: {
    isdistcountry: Boolean
  },

  data() {
    return {
      featureImgHtml: "", // PhotoGrid
      show: false, // Intro content
      product: {
        label: "Select Product",
        value: "",
        key: "name"
      },
      option1: {},
      option2: {},
      products: [
        // Product options
        {
          prodid: 48217518538945,
          partnumber: 18708,
          price: 40,
          name: "Contrology Handbook",
          available: true
        }
      ]
    };
  },

  methods: {
    // Set PhotoGrid featured image
    setFeatureImg(html) {
      this.featureImgHtml = html;
    },

    // Toggle intro content
    toggleContent() {
      this.show = !this.show;
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
  margin: 0;
  padding: 0;
}

h2 + h3 {
  display: none;
}

.intro h2 {
  display: none;
}

.intro h3 {
  display: block;
}

.intro p {
  font-family: var(--roboto);
  font-size: 0.9375rem;
  line-height: 1.467;
  color: #333;
}

.content-link {
  text-decoration: underline;
  cursor: pointer;
}

.wide {
  display: none;
}

.links {
  margin-top: 30px;
}

@media only screen and (min-width: 768px) {
  h2 + h3 {
    display: block;
    margin: 0;
  }

  .intro h3 {
    display: none;
  }

  .upper-content-wrapper {
    padding: 0 80px;
  }

  .content-wrapper {
    max-width: 530px;
    margin: 0 auto;
  }

  .links {
    column-count: 3;
    position: relative;
    margin-top: 15px;
  }

  .links > * {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .icon-link {
    margin-top: 0;
  }

  ::v-deep .modal-card-wrapper {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}

@media only screen and (min-width: 1024px) {
  .upper-content-wrapper {
    padding: 0 45px;
    display: flex;
    align-items: flex-start;
    max-width: 900px;
    margin: 0 auto 30px;
  }

  .content-wrapper {
    width: 340px;
    display: flex;
    flex-flow: column nowrap;
  }

  .intro {
    order: 1;
    margin-top: 15px;
  }

  .cta-button {
    order: 3;
    margin: 20px 0 10px;
  }

  .links {
    column-count: 1;
    order: 4;
  }

  .icon-link {
    margin: 0;
  }

  .more {
    order: 5;
    margin-top: 20px;
  }
}

@media only screen and (min-width: 1208px) {
  .wide-wrapper {
    background-color: rgba(255, 255, 255, 0.75);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto auto;
    position: relative;
    z-index: 0;
    max-width: 1050px;
    margin: 0 auto;
  }

  .upper-content-wrapper {
    display: contents;
  }

  .photo-grid-wrapper {
    grid-column: 1 / span 1;
    grid-row: 1 / span 2;
  }

  .content-wrapper {
    width: auto;
    grid-column: 2 / span 1;
    grid-row: 1 / span 1;
    margin: 50px 30px 20px 0;
    max-width: 600px;
  }

  .cta-button {
    display: none;
  }

  .cta-button.wide {
    display: flex;
    grid-column: 1 / span 1;
    grid-row: 3 / span 1;
    justify-self: center;
    margin: 0 80px 30px auto;
  }

  .intro h2,
  .intro h3 {
    display: block;
    text-align: left;
  }

  .wide-wrapper > h2,
  .wide-wrapper > h3 {
    display: none;
  }

  .links {
    column-count: 2;
    max-width: 400px;
  }

  .icon-link {
    margin: 1px;
  }
}
</style>
